import { createContext, useContext } from 'react';

export interface TourContextValue {
  startTour: () => void;
  stopTour: () => void;
  isRunning: boolean;
}

export const useTourContext = () => {
  const ctx = useContext(TourContext);
  if (!ctx) throw new Error('useTourContext must be used within a TourProvider');
  return ctx;
};

export const TourContext = createContext<TourContextValue | undefined>(undefined);
